import { getLocale } from '@/lang'
import enUS from 'antd-mobile/es/locales/en-US'
import zhCN from 'antd-mobile/es/locales/zh-CN'
import frFR from 'antd-mobile/es/locales/fr-FR'
import idID from 'antd-mobile/es/locales/id-ID'
import arSA from 'antd-mobile/es/locales/ar-SA'
import ptBR from 'antd-mobile/es/locales/pt-BR'
import urPK from '@/assets/antd_lang/ur-PK.ts'

const config: Record<string, any> = {
  'en-US': { ...enUS },
  'zh-CN': { ...zhCN },
  'fr-FR': { ...frFR },
  'id-ID': { ...idID },
  'ar-SA': { ...arSA },
  'pt-BR': { ...ptBR },
  'ur-PK': { ...urPK }
}

export function getAntdLocale() {
  const locale = getLocale()
  return config[locale] || enUS
}
